var _circle, _line, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRoleTransitionDisabledIcon = function SvgRoleTransitionDisabledIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#9BAAB6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.9467,
    y1: 8.2311,
    x2: 9.94301,
    y2: 19.7769,
    stroke: "white",
    strokeWidth: 1.76938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16485 12.6402C9.25199 12.7479 9.40832 12.7625 9.51276 12.6726C9.61784 12.5821 9.63258 12.4215 9.5448 12.3131L7.56687 9.86599L9.54544 7.41888C9.63258 7.3105 9.61848 7.14991 9.5134 7.05938C9.40832 6.96884 9.25263 6.98338 9.16549 7.09176L7.05493 9.7021C7.01648 9.74968 6.99726 9.80784 6.99726 9.86599C6.99726 9.92414 7.01648 9.9823 7.05493 10.0292L9.16485 12.6402Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.88469
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7709 9.86316H7.95269",
    stroke: "white",
    strokeWidth: 1.76938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6043 15.0464C18.5172 14.9386 18.3608 14.9241 18.2564 15.014C18.1513 15.1045 18.1366 15.2651 18.2244 15.3735L20.2023 17.8206L18.2237 20.2677C18.1366 20.3761 18.1507 20.5367 18.2558 20.6272C18.3608 20.7177 18.5165 20.7032 18.6037 20.5948L20.7142 17.9845C20.7527 17.9369 20.7719 17.8787 20.7719 17.8206C20.7719 17.7624 20.7527 17.7043 20.7142 17.6574L18.6043 15.0464Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.88469
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.908 17.8183L19.7262 17.8183",
    stroke: "white",
    strokeWidth: 1.76938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRoleTransitionDisabledIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/role-transition-disabled-icon.5ac872e4ab7ebdcd06f6c960b15bbf10.svg";